// extracted by mini-css-extract-plugin
export var centerText = "_dy-8";
export var container = "_dy-0";
export var doughnutContainer = "_dy-7";
export var legend = "_dy-a";
export var legendItemColorDisplay = "_dy-b";
export var legendItemLabel = "_dy-d";
export var legendItemValue = "_dy-c";
export var lg = "_dy-5";
export var maxWidth = "_dy-9";
export var md = "_dy-4";
export var responsive = "_dy-6";
export var sm = "_dy-3";
export var xs = "_dy-2";
export var xxs = "_dy-1";